module.exports = "<div class=\"left\">\n  <p>\n    hoge works!\n    {{ id }}\n  </p>\n  \n  <a [routerLink]=\"['']\">戻れるで</a>\n</div>\n"